import React, { useRef, useState } from 'react'
import { translate } from '../../Services/translation';

export const FileUploader = ({ onFileSelectSuccess }) => {
    const fileInput = useRef(null)
    const [fileName, setFileName] = useState('')
    const fileInputClick = e => {
        e.preventDefault();
        fileInput.current && fileInput.current.click();
    }

    const handleFileInput = (e) => {
        // handle validations
        const file = e.target.files[0];
        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 1024) {
            alert("File size cannot exceed more than 1MB");
        }
        else {
            setFileName(file.name);
            onFileSelectSuccess(file);
        }
    };

    return (
        <div className="file-uploader">
            <input type="file" onChange={handleFileInput} ref={fileInput} />
            {fileName}
            <button onClick={fileInputClick} className="button">{translate('coptikk.adminportal.upload.buttontext')}</button>
        </div>
    )
}